import costDetail from './costDetail'
import costIndexData from './costIndex'
export default {
  namespaced: true,
  modules: {
    costDetail,
    costIndexData
  }
}
